import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Nerja"
      slug="nerja"
      cp="29780"
      poblacion={22000}
      zonaGeo="Axarquía"
      lat={36.7474}
      lng={-3.8728}
      zonas={["Nerja Centro", "Burriana", "Capistrano", "Maro"]}
      landmarks={["Balcón de Europa", "Playa Burriana", "Cuevas de Nerja"]}
      municipiosLimitrofes={["Torrox", "Frigiliana"]}
      festivalLocal="Feria de Nerja (octubre)"
      contextoTipologico="Pueblo blanco turístico con altísima demanda mosquiteras en hostelería del Balcón de Europa, villas expat británicas y holandesas, ventanales abiertos al mar."
      isCoreZone={false}
    />
  );
}